import { EyeOutlined, DownloadOutlined, WarningOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Col, Divider, Row, Table, Empty, Radio, Form, Input, Popover } from "antd"
import { useState, useContext, useEffect } from "react";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
import { TemplateContext } from "../../../../utils/template_context";
import { DownloadFile } from "../../../../utils/DownloadFile";
import getStorageUser from "../../../../middlewares/GetStorageUser"


export const PerfilJurado = ({ juradoPostulacion, jurado, areaPrincipal }: any) => {
    const [openModal, setOpenModal] = useState(false);
    const [documento, setDocumento] = useState<any>({});
    const [radioValues, setRadioValues] = useState([]);
    const [user, setUser] = useState<any>({});

    const getUser = async () => {
      try {
        const _user = getStorageUser()
        setUser(_user)
      } catch (error) {
        console.log(error);
      }
    };

    const modalAnexo = (datos: any) => {
        setDocumento(datos)
        setOpenModal(true);
    }
    const context = useContext(TemplateContext);

    const [observaciones, setObservaciones] = useState(juradoPostulacion.data?.observaciones || '');

    const handleObservacionesBlur = () => {
      if (observaciones !== '') {
        console.log('Observaciones guardadas:', observaciones);
        juradoPostulacion.data.observaciones = observaciones;
        console.log('Data actualizada:', juradoPostulacion.data);
      }
    };

    useEffect(() => {
      getUser()
    }, []);

    const obtenerFecha = () => {
      let fechaActual = new Date();
      let anio = fechaActual.getFullYear();
      let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2);
      let dia = ('0' + fechaActual.getDate()).slice(-2);
      let hora = ('0' + fechaActual.getHours()).slice(-2);
      let minutos = ('0' + fechaActual.getMinutes()).slice(-2);
      let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;
      return fechaYHora
    }

    const handlechangecheck = (
      e: any,
      datos: any,
      index: number,
      postulacion: PostulacionModel
    ) => {
      if (juradoPostulacion.data.id_postulacion === postulacion.id_postulacion) {
        if (e.target.name === "checksubsanable") {
          juradoPostulacion.data.documentos_administrativos[index].checksubsanable = true;
          juradoPostulacion.data.documentos_administrativos[index].checkaceptar = false;
          juradoPostulacion.data.documentos_administrativos[index].checkcancelar = false;
          juradoPostulacion.data.documentos_administrativos[index].actualizado_por = `${user.nombres} ${user.apellidos}`
          juradoPostulacion.data.documentos_administrativos[index].fecha_subsanar = obtenerFecha()
          //props.setCountSubsanable(1);
        }
        if (e.target.name === "checkaceptar") {
          if (juradoPostulacion.data.documentos_administrativos[index].checksubsanable) {
          //props.setCountSubsanable(0);
          }
          juradoPostulacion.data.documentos_administrativos[index].checksubsanable =
            false;
          juradoPostulacion.data.documentos_administrativos[index].checkaceptar = true;
          juradoPostulacion.data.documentos_administrativos[index].checkcancelar = false;
          juradoPostulacion.data.documentos_administrativos[index].aceptado_por = `${user.nombres} ${user.apellidos}`
          juradoPostulacion.data.documentos_administrativos[index].fecha_aceptado = obtenerFecha()
        }
        if (e.target.name === "checkrechazado") {
          if (juradoPostulacion.data.documentos_administrativos[index].checksubsanable) {
          //props.setCountSubsanable(0);
          }
          juradoPostulacion.data.documentos_administrativos[index].checksubsanable =
            false;
          juradoPostulacion.data.documentos_administrativos[index].checkaceptar = false;
          juradoPostulacion.data.documentos_administrativos[index].checkcancelar = true;
          juradoPostulacion.data.documentos_administrativos[index].rechazado_por = `${user.nombres} ${user.apellidos}`
          juradoPostulacion.data.documentos_administrativos[index].fecha_rechazado = obtenerFecha()
        }
      }
      const newRadioValues = [...radioValues];
      newRadioValues[index] = e.target.value;
      setRadioValues(newRadioValues);
      //return props.setAllPostulaciones(todosJSON);
    };

    const columnasDocumentacionadministrativaModalUser : any = [
      {
        title: "No.",
        width: 40,
        render: (datos: any, datos2: any, index: number) => {
          return (
            <span>{index + 1}</span>
          );
        },
        fixed: context.device === "md" ? "left" : false,
      },
      {
        title: "Tipo de documento",
        width: 380,
        fixed: context.device === "md" ? "left" : false,
        render: (datos: any) => (
          <Row className="width-100">
            <Col span={24}>{datos.descripcion}</Col>
          </Row>
        ),
      },
      {
        title: (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Info doc
            </Col>
          </Row>
        ),
        width: 100,
        render: (datos: any, record: any, index: number) => {
          return (
            <>
              <Row className="width-100">
                <Col span={24} className="justify-content-center">
                  <Popover
                    title="Trazabilidad del documento"
                    content={
                      <div style={{fontSize: 'small'}}>
                        <p className="font-color-6435C9">Fecha subsanado: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanado}</span></p>
                        <p className="font-color-6435C9">Subsanado por: <span style={{fontWeight: 'bold'}}>{datos.subsanado_por}</span></p>
                        { datos.url_anterior && (
                          <p className="font-color-6435C9">Ver anterior: {' '}
                            <span style={{fontWeight: 'bold'}}>
                              <EyeOutlined
                              onClick={() => {
                              setOpenModal(true)
                              setDocumento(datos.url_anterior);
                              }}/>
                            </span>
                          </p>)
                        }
                        <hr />
                      </div>
                    }>
                    <InfoCircleOutlined/>
                  </Popover>
                </Col>
              </Row>
            </>
          );
        },
      },
      {
        title: (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                Acciones
              </Col>
            </Row>
            <Row className="width-100">
              <Col span={12} className="justify-content-center">
                Ver
              </Col>
              <Col span={12} className="justify-content-center">
                Descargar
              </Col>
            </Row>
          </>
        ),
        width: 120,
        render: (datos: any, record: any, index: number) => {
          return (
            <Row className="width-100">
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&
                  <EyeOutlined
                    onClick={() => {
                      modalAnexo(datos.url_participante)
                    }}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&

                  <DownloadOutlined
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
            </Row>
          );
        },
      },
    ]
    const columnasDocumentacionadministrativaModal: any = [
      {
        title: "No.",
        width: 40,
        render: (datos: any, datos2: any, index: number) => {
          return (
            <span>{index + 1}</span>
          );
        },
        fixed: context.device === "md" ? "left" : false,
      },
      {
        title: "Tipo de documento",
        width: 380,
        fixed: context.device === "md" ? "left" : false,
        render: (datos: any) => (
          <Row className="width-100">
            <Col span={24}>{datos.descripcion}</Col>
          </Row>
        ),
      },
      {
        title: (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Info doc
            </Col>
          </Row>
        ),
        width: 100,
        render: (datos: any, record: any, index: number) => {
          return (
            <>
              <Row className="width-100">
                <Col span={24} className="justify-content-center">
                  <Popover
                    title="Trazabilidad del documento"
                    content={
                      <div style={{fontSize: 'small'}}>
                        <p className="font-color-6435C9">Fecha subsanado: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanado}</span></p>
                        <p className="font-color-6435C9">Subsanado por: <span style={{fontWeight: 'bold'}}>{datos.subsanado_por}</span></p>
                        { datos.url_anterior && (
                          <p className="font-color-6435C9">Ver anterior: {' '}
                            <span style={{fontWeight: 'bold'}}>
                              <EyeOutlined
                              onClick={() => {
                              setOpenModal(true)
                              setDocumento(datos.url_anterior);
                              }}/>
                            </span>
                          </p>)
                        }
                        <hr />
                        <p className="font-color-F28C02">Fecha subsanar: <span style={{fontWeight: 'bold'}}>{datos.fecha_subsanar}</span></p>
                        <p className="font-color-F28C02">Actualizado por: <span style={{fontWeight: 'bold'}}>{datos.actualizado_por}</span></p>
                        <hr />
                        <p className="font-color-00904C">Fecha aceptado: <span style={{fontWeight: 'bold'}}>{datos.fecha_aceptado}</span></p>
                        <p className="font-color-00904C">Aceptado por: <span style={{fontWeight: 'bold'}}>{datos.aceptado_por}</span></p>
                        <hr />
                        <p className="font-color-DB2828">Fecha rechazado: <span style={{fontWeight: 'bold'}}>{datos.fecha_rechazado}</span></p>
                        <p className="font-color-DB2828">Rechazado por: <span style={{fontWeight: 'bold'}}>{datos.rechazado_por}</span></p>
                      </div>
                    }>
                    <InfoCircleOutlined/>
                  </Popover>
                </Col>
              </Row>
            </>
          );
        },
      },
      {
        title: (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Subsanar
            </Col>
          </Row>
        ),
        width: 100,
        render: (datos: any, record: any, index: number) => {
          return (
            <>
              <Row className="width-100">
                <Col span={24} className="justify-content-center">
                  <Radio
                    name="checksubsanable"
                    value={datos.checksubsanable}
                    checked={datos.checksubsanable}
                    onChange={(e) =>
                      handlechangecheck(e, datos, index, juradoPostulacion.data)
                    }
                  />
                </Col>
              </Row>
            </>
          );
        },
      },
      {
        title: (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Aceptado
            </Col>
          </Row>
        ),
        width: 100,
        render: (datos: any, record: any, index: number) => {
          return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkaceptar"
                  checked={datos.checkaceptar}
                  value={datos.checkaceptar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, juradoPostulacion.data)
                  }
                />
              </Col>
            </Row>
          );
        },
      },
      {
        title: (
          <Row className="width-100">
            <Col span={24} className="justify-content-center">
              Rechazado
            </Col>
          </Row>
        ),
        width: 100,
        render: (datos: any, record: any, index: number) => {
          return (
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                <Radio
                  name="checkrechazado"
                  checked={datos.checkcancelar}
                  value={datos.checkcancelar}
                  onChange={(e) =>
                    handlechangecheck(e, datos, index, juradoPostulacion.data)
                  }
                />
              </Col>
            </Row>
          );
        },
      },
      {
        title: (
          <>
            <Row className="width-100">
              <Col span={24} className="justify-content-center">
                Acciones
              </Col>
            </Row>
            <Row className="width-100">
              <Col span={12} className="justify-content-center">
                Ver
              </Col>
              <Col span={12} className="justify-content-center">
                Descargar
              </Col>
            </Row>
          </>
        ),
        width: 120,
        render: (datos: any, record: any, index: number) => {
          return (
            <Row className="width-100">
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&
                  <EyeOutlined
                    onClick={() => {
                      modalAnexo(datos.url_participante)
                    }}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
              <Col span={12} className="justify-content-center">
                {
                  datos && datos.url_participante !== null && datos.url_participante !== "" &&

                  <DownloadOutlined
                    onClick={() => DownloadFile(datos.url_participante)}
                  />
                }
                {
                  !(datos && datos.url_participante !== null && datos.url_participante !== "") &&
                  <WarningOutlined />
                }
              </Col>
            </Row>
          );
        },
      },
    ];

    return (
        <Row gutter={[24, 24]} style={{ padding: '20px' }}>
            <Col span={24}>
                <div className="font-size-12px font-family-Montserrat-SemiBold">Descripción del perfil</div>
                <Divider style={{margin: '2px'}} />
                <p className="font-family-Work-Sans font-size-12px font-color-535353" >{jurado.perfil}</p>
            </Col>
            <Col span={24}>
                <div className="font-size-12px font-family-Montserrat-SemiBold">Modalidad</div>
                <Divider style={{margin: '2px'}} />
                <p className="font-family-Work-Sans font-size-12px font-color-535353">
                  {jurado?.areas_conocimientos?.[0]?.tipo_conocimiento === 1
                    ? "Experto con título"
                    : jurado?.areas_conocimientos?.[0]?.tipo_conocimiento === 2
                    ? "Experto sin título"
                    : ""}
                </p>
            </Col>
            <Col span={24}>
                <div className="font-size-12px font-family-Montserrat-SemiBold">Área principal de conocimiento</div>
                <Divider style={{margin: '2px'}} />
                <p className="font-family-Work-Sans font-size-12px font-color-535353" >{juradoPostulacion.data.area}</p>
            </Col>
            <Col span={24} >
                <div className="font-size-12px font-family-Montserrat-SemiBold">Categorías de conocimiento (SCC)</div>
                <Divider style={{margin: '2px'}} />
                <ul className="font-color-051923bf" style={{paddingLeft: '14px'}}>
                    {(juradoPostulacion.data.categorias_area || []).map((x: any) => (
                      <li className="font-family-Work-Sans font-size-12px font-color-051923bf" key={x.id}>
                        <span className="font-color-535353">{x.nombre}</span>
                      </li>
                    ))}
                </ul>
            </Col>
            <Col span={24}>
              <div className="font-size-12px font-family-Montserrat-SemiBold">Categorías de conocimiento (SCC)</div>
              <Divider style={{ margin: '2px' }} />
              <ul className="font-color-051923bf" style={{ paddingLeft: '14px' }}>
                {jurado?.areas_conocimientos?.[0]
                  ? jurado.areas_conocimientos[0].areas_conocimientos.map((x: any) => (
                      <li className="font-family-Work-Sans font-size-12px font-color-051923bf" key={x.id}>
                        <span className="font-color-535353">{x.nombre}</span>
                      </li>
                    ))
                  : (juradoPostulacion.data.categorias_area || []).map((x: any) => (
                    <li className="font-family-Work-Sans font-size-12px font-color-051923bf" key={x.id}>
                      <span className="font-color-535353">{x.nombre}</span>
                    </li>
                  ))}
              </ul>
            </Col>
            {openModal &&
                <ModalVisualizarDocumentos
                    visualizar={openModal}
                    setVisualizar={setOpenModal}
                    state={{ documento }}
                />
            }
            {
            <Col span={24} >
              <div
                className="col-12 font-family-Montserrat-Regular font-size-13px"
                style={{ paddingTop: "16px", paddingBottom: "1%" }}
              >
                <label className="font-family-Montserrat-SemiBold">
                  Documentos administrativos
                </label>
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  pagination={false}
                  columns={user.role_id != 3 ? columnasDocumentacionadministrativaModal : columnasDocumentacionadministrativaModalUser}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  dataSource={juradoPostulacion.data.documentos_administrativos == '{}' ? '' : juradoPostulacion.data.documentos_administrativos}
                />
              </div>
            </Col>
            }
            {
            user.role_id != 3 ?
              <Col
                span={24}
                className="font-family-Montserrat-Regular font-size-13px"
                style={{ paddingTop: "16px", paddingBottom: "1%" }}
              >
                <Form
                  name="basic"
                  layout="vertical"
                  initialValues={{ remember: true }}
                  autoComplete="off"
                >
                  <Input.TextArea
                    value={observaciones}
                    rows={10}
                    maxLength={2000}
                    required
                    onBlur={handleObservacionesBlur}
                    onChange={(e) => setObservaciones(e.target.value)}
                    placeholder="Ingresa las observaciones"
                    />
                </Form>
              </Col>
              :
              <span>{observaciones}</span>
            }
        </Row>
    )
}
